import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './presentation/App';
import reportWebVitals from './reportWebVitals';
import { initializeApp } from './infrastructure/config';

// Inicializamos la configuración de la aplicación
initializeApp();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
    <App />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
